import cn from 'classnames';

import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import type { Offer } from '../types';

import styles from './styles.module.scss';

interface OfferRewardProps {
  reward: Offer['reward'];
}

export const OfferReward = ({ reward }: OfferRewardProps) => (
  <Card color="light" size={16}>
    <Space size={12} justify="space-between" align="center">
      <Text size={16} strong>
        Доход
      </Text>
      <Space direction="vertical" align="end" className={cn(reward.hint && styles['amount-with-hint'])}>
        <Text size={16} strong>
          {reward.amount}
        </Text>
        {reward.hint && <Text size={8}>{reward.hint}</Text>}
      </Space>
    </Space>
  </Card>
);
